var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#event--warning_svg__clip0_61530_7459)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.535 21h-5.072L18 15.927 20.535 21zM18 13.5a.75.75 0 00-.671.415l-3.75 7.5a.75.75 0 00.671 1.085h7.5a.75.75 0 00.691-1.042l-3.77-7.543A.75.75 0 0018 13.5zM12 17.25a1.125 1.125 0 100 2.25 1.125 1.125 0 000-2.25zM12.75 9h-1.5v6.75h1.5V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5h-9a.75.75 0 01-.665-1.096l9.75-18.75A.763.763 0 0112 2.25c.268 0 .536.156.665.404l4.5 8.654-1.33.692L12 4.626 3.485 21h7.765v1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "event--warning_svg__clip0_61530_7459"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgEventWarning;